<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeModeReglement.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit"
               :class="{'button-access-no-permission' :
               !checkPermissions(permsModeReglement.maj) }"
               @click="checkPermissions(permsModeReglement.maj)
          ? addOrEditModeReglement(null) : showPopUp()">
              {{ $t('listeModeReglement.actions.add')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="$refs.tableModeReglement.refresh()" class="column is-12">
            <b-input :placeholder="$t('listeModeReglement.actions.search')"
                     type="search" icon="magnify"
                     v-model="filterInput">
            </b-input>
          </form>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <a @click="inProgress()">
            <p class="has-text-right lien mgb-8px">
              {{ $t('listeModeReglement.actions.archive')}}
            </p>
          </a>
        </div>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      ref="tableModeReglement">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableModeReglement.setLimit($event)"/>
      </template>
      <div slot="aEffet" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.aEffet" type="is-default"
                    class="pointer-events-none">
        </b-checkbox>
      </div>
      <div slot="ribObligatoire" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.ribObligatoire" type="is-default"
                    class="pointer-events-none">
        </b-checkbox>
      </div>
      <div slot="centralisationCompteBanque" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.centralisationCompteBanque" type="is-default"
                    class="pointer-events-none">
        </b-checkbox>
      </div>
      <div slot="aEffet" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.aEffet" type="is-default"
                    class="pointer-events-none">
        </b-checkbox>
      </div>
      <div slot="traite" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.traite" type="is-default"
                    class="pointer-events-none">
        </b-checkbox>
      </div>
      <div slot="prelevement" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.prelevement" type="is-default"
                    class="pointer-events-none">
        </b-checkbox>
      </div>
      <div slot="actionAchat" slot-scope="props">
        {{ $t(getLibelleActionAchat(props.row.actionAchat)) }}
      </div>
      <div slot="archiver" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permsModeReglement.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="archive" type="is-default"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsModeReglement.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(permsModeReglement.maj) ?
           addOrEditModeReglement(props.row) : showPopUp()">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsModeReglement.maj)
              }"
          >
          </b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permsModeReglement.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="delete-forever" type="is-danger"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsModeReglement.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
    </v-server-table>
    <b-modal v-model="popUpAddEditModeReglement" has-modal-card class="modal">
      <pop-up-add-edit-mode-reglement :modeReglement="selectedModeReglement"
                                      @reloadModeReglement="$refs.tableModeReglement.refresh()"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import inProgress from '@/services/general/inProgress';
import { MODE_REGLEMENT } from '@/configuration/general/permissionsParametrageConf';
import breadcrumb from '@/components/general/breadcrumb';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import genererModeReglement from '@/services/parametrage/generation/genererModeReglement';
import popUpAddEditModeReglement from '@/components/parametrage/modeReglement/popUpAddEditModeReglement';
import TableItemsInView from '@/components/general/TableItemsInView';
import { LISTE_ACTION_ACHAT } from '@/configuration/parametrage/modeReglementConf';

const permissions = createNamespacedHelpers('permissions');
const ModeReglement = createNamespacedHelpers('modeReglement');

export default {
  data() {
    return {
      filter: '',
      filterInput: '',
      permsModeReglement: MODE_REGLEMENT,
      popUpAddEditModeReglement: false,
      selectedModeReglement: {},
      loadingComponent: null,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    popUpAddEditModeReglement,
    TableItemsInView,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeModeReglement.title'), route: { name: '' }, isActive: true },
      ];
    },
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...ModeReglement.mapGetters({
      listeModeReglement: 'items',
      totalCount: 'totalCount',
    }),
    listeModeReglementFilter() {
      return this.listeModeReglement.filter(item => {
        return item.libelle.toLowerCase().includes(this.filter.toLocaleLowerCase()
          || this.filter);
      });
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeModeReglement.tab.libelle'),
          aEffet: this.$t('listeModeReglement.tab.aEffet'),
          centralisationCompteBanque: this.$t('listeModeReglement.tab.centralisationCompteBanque'),
          ribObligatoire: this.$t('listeModeReglement.tab.ribObligatoire'),
          actionAchat: this.$t('listeModeReglement.tab.actionAchat'),
          traite: this.$t('listeModeReglement.tab.traite'),
          prelevement: this.$t('listeModeReglement.tab.prelevement'),
          codeExterneComptabilite: this.$t('listeModeReglement.tab.codeExterneComptabilite'),
          codeExterneFactor: this.$t('listeModeReglement.tab.codeExterneFactor'),
          archiver: '',
          edit: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          archiver: 'colonneSelected',
          aEffet: 'colonneAction',
          traite: 'colonneAction',
          prelevement: 'colonneAction',
          ribObligatoire: 'colonneRibObligatoire',
          centralisationCompteBanque: 'colonneWidth270px',
          codeExterneComptabilite: 'colonneWidth270px',
          codeExterneFactor: 'colonneWidth270px',
        },
        sortable: ['libelle', 'aEffet', 'centralisationCompteBanque', 'ribObligatoire', 'traite', 'actionAchat', 'prelevement', 'codeExterneFactor', 'codeExterneComptabilite'],
        requestFunction: ((data) => {
          data.query = {
            auto: this.filterInput,
          };
          return this.actionsLoadModeReglement(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.listeModeReglement,
            count: this.totalCount,
          };
        }),
      };
    },
    columns() {
      return ['libelle', 'aEffet', 'centralisationCompteBanque', 'ribObligatoire', 'traite', 'prelevement', 'actionAchat', 'codeExterneFactor', 'codeExterneComptabilite', 'edit', 'archiver', 'delete'];
    },
  },
  methods: {
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...ModeReglement.mapActions({
      actionsLoadModeReglement: 'loadModeReglement',
    }),
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    getLibelleActionAchat(code) {
      const actionAchatFind = LISTE_ACTION_ACHAT.find((actionAchat) => {
        return actionAchat.code === code;
      });
      return actionAchatFind ? actionAchatFind.libelle : null;
    },
    addOrEditModeReglement(modeReglement) {
      if (!modeReglement) this.selectedModeReglement = genererModeReglement();
      else this.selectedModeReglement = cloneDeep(modeReglement);
      this.popUpAddEditModeReglement = true;
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageParametrage.modeReglement.liste'));
  },
};

</script>
